import React, { Fragment } from 'react';
import {
  AppUserAdminActionCreators,
  ApplicationState,
  AppActionCreators,
  AppState
} from '../../../store';
import { RouteComponentProps } from 'react-router';
import { connect } from 'react-redux';
import {
  Button,
  Card,
  Box,
  Divider,
  Grid,
  IconButton,
  Tooltip,
  Slider,
  FormControlLabel,
  Switch
} from '@material-ui/core';
import Autocomplete, { RenderInputParams } from '@material-ui/lab/Autocomplete';
import { ITranslatorService } from '../../../services/Interfaces/ITranslatorService';
import { ApplicationContext, AppContext } from '../../../context/Contexts';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import { withSnackbar, ProviderContext } from 'notistack';
import { IReferentialService } from '../../../services/Interfaces/IReferentialService';
import { DateLaborService, Tariff, TariffType, TariffValue } from '../../../interfaces/Tariff';
import { ITariffService } from '../../../services/Interfaces/ITariffService';
import { ICaseService } from '../../../services/Interfaces/ICaseService';
import moment from 'moment';

import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import NumberFormat from 'react-number-format';
import { IReferential } from '../../../interfaces/IReferential';
import { CountryCodeEnum, ReferentialCode, RoleClaimsEnum, TariffCategoryCodeEnum, TariffTypeCodeEnum } from '../../../helpers/Constants';
import Referentials from '../../../helpers/Referentials.json';
import AddCircleTwoToneIcon from '@material-ui/icons/AddCircleTwoTone';
import EditCircleTwoToneIcon from '@material-ui/icons/EditTwoTone';
import DeleteCircleTwoToneIcon from '@material-ui/icons/DeleteOutlineTwoTone';
import RemoveIcon from '@material-ui/icons/RemoveCircleOutlineTwoTone';
import MomentUtils from '@date-io/moment';
import 'moment/locale/en-gb';
import 'moment/locale/ro';
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date';
import _ from 'lodash';

class LocalizedUtils extends MomentUtils {
  // dateFormat = "DD MM YYYY";
}
interface TariffIntervalValue {
  start: number;
  end: number;
  value: number;
}

interface IEditTarifLaborTabState {
  tariffValues: TariffValue[];
  isLoading: boolean;
  activeAction: number;

  selectedTariffTypes: TariffType[];
  selectedBrands: IReferential[];
  selectedDate: Date | null;
  selectedValue: number;
  selectedOfferValue: number;
  selectedMarginValue: number;
  isVehicleAge: boolean;
  selectedSliderValues: number[];
  selectedValues: number[];
  selectedOfferValues: number[];
  selectedMarginValues: number[];

  minDate: Date;
  tariffTypeList: TariffType[];
  brandList: IReferential[];
  insurerList: IReferential[];
  selectedInsurer: IReferential[];
  vehicleTypeList: IReferential[];
  selectedVehicleType: IReferential[];
  jobTypeList: IReferential[];
  selectedJobType: IReferential[];
  regionList: IReferential[];
  selectedRegion: IReferential[];
}

export interface ExternalEditTarifLaborTabProps {
  tariffId: number;
  tariffGroupTypeId: number;
  tariffGroupTypeName: string;
  tariffGroupTypeCode: string;
  currency: string;
  tariff: Tariff;
}

type EditTarifLaborTabProps = { appState: AppState } & ProviderContext &
  ExternalEditTarifLaborTabProps &
  RouteComponentProps<{ id: string }>;

const START = 0;
const END = 10;
const DEFAULT = 5;
const MAXLOBOURVALUE = 600;

class EditTarifLaborTabf extends React.PureComponent<
  EditTarifLaborTabProps,
  IEditTarifLaborTabState
> {
  private translatorService!: ITranslatorService;
  private appReferentialService!: IReferentialService;
  private tariffService!: ITariffService;
  private caseService!: ICaseService;

  momutil = new MomentUtils();
  static contextType = ApplicationContext;

  defaultBrand = {
    name: 'All', //this.translatorService.Tranlate("SELECT_ALL_OPTION", "Toate"),
    displayName: 'All', //this.translatorService.Tranlate("SELECT_ALL_OPTION", "Toate"),
    id: -1,
    isActive: true
  } as IReferential;

  defaultInsurer = {
    name: 'None', //this.translatorService.Tranlate('SELECT_NONE_OPTION', 'Niciunul'),
    displayName: 'None', //this.translatorService.Tranlate('SELECT_NONE_OPTION', 'Niciunul'),
    id: -1,
    isActive: true
  } as IReferential;

  defaultVehicleType = {
    name: 'All',
    displayName: 'All',
    id: -1,
    isActive: true
  } as IReferential;

  defaultJobType = {
    name: 'All',
    displayName: 'All',
    id: -1,
    isActive: true
  } as IReferential;

  defaultRegion = {
    name: 'All',
    displayName: 'All',
    id: -1,
    isActive: true
  } as IReferential;

  state = {
    tariffValues: [] as TariffValue[],
    isLoading: true,
    isVehicleAge: false,
    activeAction: 0,
    selectedTariffTypes: [] as TariffType[],
    selectedBrands: [this.defaultBrand] as IReferential[],
    minDate: new Date(),
    tariffTypeList: [] as TariffType[],
    brandList: [] as IReferential[],
    insurerList: [] as IReferential[],
    selectedInsurer: [this.defaultInsurer] as IReferential[],
    vehicleTypeList: [] as IReferential[],
    selectedVehicleType: [this.defaultVehicleType] as IReferential[],
    jobTypeList: [] as IReferential[],
    selectedJobType: [this.defaultJobType] as IReferential[],
    regionList: [] as IReferential[],
    selectedRegion: [this.defaultRegion] as IReferential[],
    selectedSliderValues: [DEFAULT] as number[],
    selectedValues: [0, 0] as number[],
    selectedOfferValues: [0, 0] as number[],
    selectedValue: 0,
    selectedOfferValue: 0,
    selectedMarginValue: 0,
    selectedMarginValues: [0, 0] as number[]
  } as IEditTarifLaborTabState;

  componentDidMount = () => {
    moment.locale(this.props.appState.language);

    this.setState(
      {
        isLoading: true
      },
      () => {
        this.loadData();
      }
    );

    
    ValidatorForm.addValidationRule('isGreaterThanZero', (value) => {
      if (value == 0) {
        return false;
      }
      return true;
    });

    ValidatorForm.addValidationRule('isGratterThanMinValue', (value) => {
      if (value < MAXLOBOURVALUE) {
        return false;
      }
      return true;
    });
  };

  compareName = (a: IReferential, b: IReferential) => {
    const nameA = a === null ? '' : a.displayName!.toUpperCase();
    const nameB = b === null ? '' : b.displayName!.toUpperCase();
    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }

    return 0;
  };

  loadData = async () => {
    try {
      this.defaultBrand.name = this.translatorService.Tranlate('SELECT_ALL_OPTION', 'Toate');
      this.defaultBrand.displayName = this.translatorService.Tranlate('SELECT_ALL_OPTION', 'Toate');

      this.defaultInsurer.name = this.translatorService.Tranlate('SELECT_NONE_OPTION', 'Niciunul');
      this.defaultInsurer.displayName = this.translatorService.Tranlate(
        'SELECT_NONE_OPTION',
        'Niciunul'
      );

      this.defaultVehicleType.name = this.translatorService.Tranlate('SELECT_ALL_OPTION', 'Toate');
      this.defaultVehicleType.displayName = this.translatorService.Tranlate(
        'SELECT_ALL_OPTION',
        'Toate'
      );

      this.defaultJobType.name = this.translatorService.Tranlate('SELECT_ALL_OPTION', 'Toate');
      this.defaultJobType.displayName = this.translatorService.Tranlate(
        'SELECT_ALL_OPTION',
        'Toate'
      );

      this.defaultRegion.name = this.translatorService.Tranlate('SELECT_ALL_OPTION', 'Toate');
      this.defaultRegion.displayName = this.translatorService.Tranlate(
        'SELECT_ALL_OPTION',
        'Toate'
      );

      const brandRef = Referentials.referential.find(
        (item) => item.code === ReferentialCode.CarBrands
      );
      const insurerRef = Referentials.referential.find(
        (item) => item.code === ReferentialCode.Insurer
      );
      const vehicleTypeRef = Referentials.referential.find(
        (item) => item.code === ReferentialCode.TariffVehicleType
      );
      const regionRef = Referentials.referential.find(
        (item) => item.code === ReferentialCode.Region
      );

      const countryCode = this.props.tariff?.owner?.country?.code || '';

      const [tariffTypeList, brandList, insurerList, vehicleTypeList, tariffValues, jobTypeList, regionList] = await Promise.all([
        this.tariffService.GetTariffTypes(this.props.tariffGroupTypeId),
        this.appReferentialService.Get(brandRef!.baseUrl),
        this.appReferentialService.Get(insurerRef!.baseUrl),
        this.appReferentialService.Get(vehicleTypeRef!.baseUrl),
        this.tariffService.GetTariffValues(this.props.tariffId, this.props.tariffGroupTypeId),
        countryCode ? this.caseService.GetJobTypeByCountryCode(countryCode) : Promise.resolve([] as IReferential[]),
        this.appReferentialService.Get(regionRef!.baseUrl)
      ]);

      const brandList1 = brandList.sort(this.compareName);
      brandList.unshift(this.defaultBrand);

      const insurerList1 = _.cloneDeep(insurerList).sort(this.compareName);
      insurerList1.unshift(this.defaultInsurer);

      const vehicleTypeList1 = _.cloneDeep(vehicleTypeList).sort(this.compareName);
      vehicleTypeList1.unshift(this.defaultVehicleType);

      const jobTypeList1 = _.cloneDeep(jobTypeList).sort(this.compareName);
      jobTypeList1.unshift(this.defaultJobType);

      // regions of the organization's country only
      const ownerCountryId = this.props.tariff?.owner?.countryId;
      const regionList1 = _.cloneDeep(regionList)
        .filter((item) => !!ownerCountryId && item.dependencyId === ownerCountryId)
        .sort(this.compareName);
      regionList1.unshift(this.defaultRegion);

      this.setState({
        tariffTypeList: tariffTypeList.filter((item) => item.isActive === true),
        tariffValues: tariffValues,
        brandList: brandList1.filter((item) => item.isActive === true),
        insurerList: insurerList1.filter((item) => item.isActive === true),
        vehicleTypeList: vehicleTypeList1.filter((item) => item.isActive === true),
        jobTypeList: jobTypeList1.filter((item) => item.isActive === true),
        regionList: regionList1.filter((item) => item.isActive === true),
        isLoading: false
      });
    } catch (error) {
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    }
  };

  handleTariffTypeChange = (event: React.ChangeEvent<any>, values: TariffType[]) => {
    this.setState({ selectedTariffTypes: values });
  };

  saveTariffValues = async (activeButton: number) => {
    const tariffValuesToSave = [] as TariffValue[];

    let date = new Date();
    if (moment.isDate(this.state.selectedDate)) {
      date = moment.utc(this.state.selectedDate.toDateString()).local().toDate();
    } else {
      date = moment.utc(this.state.selectedDate).local().toDate();
    }

    for (const tariffType of this.state.selectedTariffTypes) {
      for (const insurer of this.state.selectedInsurer) {
        for (const vehicleType of this.state.selectedVehicleType) {
          for (const jobType of this.state.selectedJobType) {
            for (const region of this.state.selectedRegion) {
              for (const brand of this.state.selectedBrands) {
                if (this.state.isVehicleAge) {
                  for (let i = 0; i < this.state.selectedSliderValues.length; i++) {
                    const tariffValue = {
                      brandId: brand.id === this.defaultBrand.id ? null : brand.id,
                      tariffId: this.props.tariffId,
                      tariffTypeId: tariffType.id,
                      date: date,
                      value: this.state.selectedValues[i],
                      offerValue: this.state.selectedOfferValues[i],
                      marginValue: this.state.selectedMarginValues[i],
                      startVehicleYear: i === 0 ? null : this.state.selectedSliderValues[i - 1],
                      endVehicleYear: this.state.selectedSliderValues[i],
                      insurerId: insurer.id === this.defaultInsurer.id ? null : insurer.id,
                      vehicleTypeId: vehicleType.id === this.defaultVehicleType.id ? null : vehicleType.id,
                      jobTypeId: jobType.id === this.defaultJobType.id ? null : jobType.id,
                      regionId: region.id === this.defaultRegion.id ? null : region.id
                    } as TariffValue;
                    tariffValuesToSave.push(tariffValue);

                    if (i === this.state.selectedSliderValues.length - 1) {
                      tariffValuesToSave.push({
                        brandId: brand.id === this.defaultBrand.id ? null : brand.id,
                        tariffId: this.props.tariffId,
                        tariffTypeId: tariffType.id,
                        date: date,
                        value: this.state.selectedValues[i + 1],
                        offerValue: this.state.selectedOfferValues[i + 1],
                        marginValue: this.state.selectedMarginValues[i + 1],
                        startVehicleYear: this.state.selectedSliderValues[i],
                        endVehicleYear: null,
                        insurerId: insurer.id === this.defaultInsurer.id ? null : insurer.id,
                        vehicleTypeId: vehicleType.id === this.defaultVehicleType.id ? null : vehicleType.id,
                        jobTypeId: jobType.id === this.defaultJobType.id ? null : jobType.id,
                        regionId: region.id === this.defaultRegion.id ? null : region.id
                      } as TariffValue);
                    }
                  }
                } else {
                  const tariffValue = {
                    brandId: brand.id === this.defaultBrand.id ? null : brand.id,
                    tariffId: this.props.tariffId,
                    tariffTypeId: tariffType.id,
                    date: date,
                    value: this.state.selectedValue,
                    offerValue: this.state.selectedOfferValue,
                    marginValue: this.state.selectedMarginValue,
                    startVehicleYear: null,
                    endVehicleYear: null,
                    insurerId: insurer.id === this.defaultInsurer.id ? null : insurer.id,
                    vehicleTypeId: vehicleType.id === this.defaultVehicleType.id ? null : vehicleType.id,
                    jobTypeId: jobType.id === this.defaultJobType.id ? null : jobType.id,
                    regionId: region.id === this.defaultRegion.id ? null : region.id
                  } as TariffValue;
                  tariffValuesToSave.push(tariffValue);
                }
              }
            }
          }
        }
      }
    }
    if (activeButton === 1) {
      const dataLaborServices = this.structureTariffValuesAccordingToDate();    
      // Get tariffValues from the first element of dataLaborServices, or an empty array if not present
      const data = dataLaborServices.length > 0 ? dataLaborServices[0].tariffValues : [];
      console.log('tariffValuesToSave', tariffValuesToSave, 'dataLaborServices:', dataLaborServices, 'data:', data);
      if (tariffValuesToSave.length > 0) {
        const date = tariffValuesToSave[0].date;
        // Filter out items in 'data' that are not in 'tariffValuesToSave', and update their date
        const itemsToBeUpdated = data
          .filter(dataItem =>
            !tariffValuesToSave.some(saveItem => this.isMatchingItem(dataItem, saveItem))
          )
          .map(item => (
            {
              brandId: item.brandId,
              tariffId: item.tariffId,
              tariffTypeId: item.tariffTypeId,
              date: date,
              value: item.value,
              offerValue: item.offerValue,
              marginValue: item.marginValue,
              startVehicleYear: item.startVehicleYear,
              endVehicleYear: item.endVehicleYear,
              insurerId: item.insurerId,
              vehicleTypeId: item.vehicleTypeId,
              jobTypeId: item.jobTypeId,
              regionId: item.regionId
            } as TariffValue
          ));
        console.log('Items in data but not in tariffValuesToSave:', itemsToBeUpdated);
        // Add the items to 'tariffValuesToSave'
        tariffValuesToSave.push(...itemsToBeUpdated);
        console.log('tariffValuesToSave after adding items:', tariffValuesToSave);
      }
    }
    
    try {
      await this.tariffService.UpdateTariffValues(tariffValuesToSave);

      this.setState(
        {
          isLoading: true,
          selectedTariffTypes: []
        },
        () => {
          this.loadData();
        }
      );

      this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
        variant: 'success'
      });
    } catch (error) {
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    }
  };

  public isMatchingItem = (item1: TariffValue, item2 : TariffValue) : boolean => {
    return item1.tariffId === item2.tariffId &&
           item1.tariffTypeId === item2.tariffTypeId &&
           item1.insurerId === item2.insurerId &&
           (!item1.vehicleTypeId || item1.vehicleTypeId === item2.vehicleTypeId || !item2.vehicleTypeId) &&
           (!item1.jobTypeId || item1.jobTypeId === item2.jobTypeId || !item2.jobTypeId) &&
           (!item1.regionId || item1.regionId === item2.regionId || !item2.regionId) &&
           (!item1.brandId || item1.brandId === item2.brandId || !item2.brandId);
  }

  public hasRight = (right: string): boolean => {
    return this.props.appState!.user!.profile.role.includes(right);
  };


  handleDateChange = (date: MaterialUiPickersDate | null, value?: string | null) => {
    if (date === null || !date.isValid) {
      return;
    }
    this.setState({ selectedDate: date!.toDate() });
  };

  handleBrandChange = (newValue: IReferential[]) => {
    const allIndex = newValue.findIndex((item) => item.id === this.defaultBrand.id);

    if (allIndex === newValue.length - 1) {
      this.setState({ selectedBrands: [this.defaultBrand] });
      return;
    }
    if (allIndex === 0 && newValue.length > 1) {
      this.setState({ selectedBrands: [newValue[1]] });
      return;
    }

    this.setState({ selectedBrands: newValue });
  };

  handleInsurerChange = (newValue: IReferential[]) => {
    this.setState({ selectedInsurer: newValue });
  };

  handleVehicleTypeChange = (newValue: IReferential[]) => {
    const allIndex = newValue.findIndex((item) => item.id === this.defaultVehicleType.id);

    if (allIndex === newValue.length - 1) {
      this.setState({ selectedVehicleType: [this.defaultVehicleType] });
      return;
    }
    if (allIndex === 0 && newValue.length > 1) {
      this.setState({ selectedVehicleType: [newValue[1]] });
      return;
    }

    this.setState({ selectedVehicleType: newValue });
  };

  handleJobTypeChange = (newValue: IReferential[]) => {
    const allIndex = newValue.findIndex((item) => item.id === this.defaultJobType.id);

    if (allIndex === newValue.length - 1) {
      this.setState({ selectedJobType: [this.defaultJobType] });
      return;
    }
    if (allIndex === 0 && newValue.length > 1) {
      this.setState({ selectedJobType: [newValue[1]] });
      return;
    }

    this.setState({ selectedJobType: newValue });
  };

  handleRegionChange = (newValue: IReferential[]) => {
    const allIndex = newValue.findIndex((item) => item.id === this.defaultRegion.id);

    if (allIndex === newValue.length - 1) {
      this.setState({ selectedRegion: [this.defaultRegion] });
      return;
    }
    if (allIndex === 0 && newValue.length > 1) {
      this.setState({ selectedRegion: [newValue[1]] });
      return;
    }

    this.setState({ selectedRegion: newValue });
  };

  NumberFormatCustom = (props: any) => {
    const { inputRef, onChange, ...other } = props;

    return (
      <NumberFormat
        {...other}
        getInputRef={inputRef}
        onValueChange={(values: any) => {
          onChange({
            target: {
              value: values.value
            }
          });
        }}
        allowNegative={false}
        decimalScale={2}
        isNumericString
      />
    );
  };

  handleValueChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.value === '') {
      this.setState({ selectedValue: 0 });
      return;
    }

    this.setState({
      selectedValue: event.target.value === null ? 0 : parseFloat(event.target.value)
    });
  };

  handleOfferValueChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.value === '') {
      this.setState({ selectedOfferValue: 0 });
      return;
    }
    this.setState({
      selectedOfferValue: event.target.value === null ? 0 : parseFloat(event.target.value)
    });
  };

  handleMarginValueChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.value === '') {
      this.setState({ selectedMarginValue: 0 });
      return;
    }
    this.setState({
      selectedMarginValue: event.target.value === null ? 0 : parseFloat(event.target.value)
    });
  };

  handleValuesChange = (event: React.ChangeEvent<HTMLInputElement>, index: number) => {
    const newValues = [...this.state.selectedValues];
    if (event.target.value === '') {
      newValues[index] = 0;
    } else {
      newValues[index] = event.target.value === null ? 0 : parseFloat(event.target.value);
    }

    this.setState({ selectedValues: newValues });
  };

  handleOfferValuesChange = (event: React.ChangeEvent<HTMLInputElement>, index: number) => {
    const newValues = [...this.state.selectedOfferValues];
    if (event.target.value === '') {
      newValues[index] = 0;
    } else {
      newValues[index] = event.target.value === null ? 0 : parseFloat(event.target.value);
    }
    newValues[index] = event.target.value === null ? 0 : parseFloat(event.target.value);

    this.setState({ selectedOfferValues: newValues });
  };

  handleMarginValuesChange = (event: React.ChangeEvent<HTMLInputElement>, index: number) => {
    const newValues = [...this.state.selectedMarginValues];
    if (event.target.value === '') {
      newValues[index] = 0;
    } else {
      newValues[index] = event.target.value === null ? 0 : parseFloat(event.target.value);
    }
    newValues[index] = event.target.value === null ? 0 : parseFloat(event.target.value);

    this.setState({ selectedMarginValues: newValues });
  };

  handleChange = (event: any, newvalue: number | number[]) => {
    const newValues = newvalue as number[];

    this.setState({ selectedSliderValues: newValues });

    return;
  };

  getMarks = (total: number) => {
    const result: any[] = [];
    for (let i = 0; i <= total; i++) {
      result.push({
        value: i,
        label: i.toString()
      });
    }

    return result;
  };

  removeSliderValue = () => {
    if (this.state.selectedSliderValues.length === 1) {
      return;
    }

    const values = [...this.state.selectedSliderValues];
    const tValues = [...this.state.selectedValues];
    const tOfferValues = [...this.state.selectedOfferValues];
    const tMarginValues = [...this.state.selectedMarginValues];

    values.pop();
    tValues.pop();
    tOfferValues.pop();

    this.setState({
      selectedSliderValues: values,
      selectedValues: tValues,
      selectedOfferValues: tOfferValues,
      selectedMarginValues: tMarginValues
    });
  };

  addSliderValue = () => {
    this.setState({
      selectedSliderValues: [...this.state.selectedSliderValues, END],
      selectedValues: [...this.state.selectedValues, 0],
      selectedOfferValues: [...this.state.selectedOfferValues, 0],
      selectedMarginValues: [...this.state.selectedMarginValues, 0]
    });
  };

  getValidators() {
    const { tariffGroupTypeCode, tariff } = this.props;
    const isManType = tariffGroupTypeCode === TariffCategoryCodeEnum.MAN.toString();
    const isCzechRepublic = tariff?.owner?.country?.code?.toUpperCase() === CountryCodeEnum.CZ.toString();
  
    const validators = ['required'];
  
    if (isManType) {
      validators.push('isGreaterThanZero');
      if (isCzechRepublic) validators.push('isGratterThanMinValue');
    }
  
    return validators;
  }
  
  getErrorMessages() {
    const { tariffGroupTypeCode, tariff } = this.props;
    const isManType = tariffGroupTypeCode === TariffCategoryCodeEnum.MAN.toString();
    const isCzechRepublic = tariff?.owner?.country?.code?.toUpperCase() === CountryCodeEnum.CZ.toString();
    console.log(tariff.owner?.country);
    const messages = [
      this.translatorService.Tranlate('VALIDATORS_REQUIRED', 'Campul este obligatoriu')
    ];
  
    if (isManType) {
      messages.push(
        this.translatorService.Tranlate(
          'LABOR_VALUE_SHOULD_BE_GREATER_THAN_ZERO',
          'Valoarea trebuie sa fie mai mare decat 0'
        )
      );
  
      if (isCzechRepublic) {
        messages.push(
          this.translatorService.Tranlate(
            'LABOR_VALUE_CZ_SHOULD_BE_GREATER_THAN',
            `Valoarea trebuie sa fie mai mare decat ${MAXLOBOURVALUE}`
          )
        );
      }
    }
  
    return messages;
  }  

  shouldShowBrandDropdown = (): boolean => {
    const code = this.props.tariffGroupTypeCode;

    if (
      code === TariffCategoryCodeEnum.ADAOS.toString() ||
      code === TariffCategoryCodeEnum.ADAOS_ASIGURATOR.toString() ||
      code === TariffCategoryCodeEnum.ADAOS_ALT_PART.toString()
    ) {
      return false;
    }

    if (code === TariffCategoryCodeEnum.DISC.toString()) {
      return this.state.selectedTariffTypes.some(
        (item) => item.code === TariffTypeCodeEnum.PSE.toString()
      );
    }

    return true;
  };

  renderEditTariffValues = (activeButton: number) => {
    return (
      <ValidatorForm onSubmit={() => this.saveTariffValues(activeButton)} instantValidate={true}>
        <Divider />
        <Box m={1} p={0} className="m-4">
          <MuiPickersUtilsProvider
            libInstance={moment}
            utils={LocalizedUtils}
            locale={this.props.appState.language}
          >
            <Box mb={2}>
              <DatePicker
                fullWidth
                disabled={activeButton === 1 ? true : false}
                variant="inline"
                format={this.props.appState.dateFormat.toUpperCase()}
                margin="normal"
                id="date-picker-inline"
                label={this.translatorService.Tranlate('TARIFF_EDIT_LABOR_TAB_DATE_LABEL', 'De la')}
                value={this.state.selectedDate}
                onChange={this.handleDateChange}
                autoOk={true}
                minDate={activeButton === 1 ? null : this.state.minDate}
                //clearLabel = {false}
                // KeyboardButtonProps={{
                //     'aria-label': 'change date',
                // }}
              />
            </Box>
          </MuiPickersUtilsProvider>
          {this.props.tariffGroupTypeCode === TariffCategoryCodeEnum.ADAOS.toString() ? null : (
            !this.hasRight(RoleClaimsEnum.AdminService) && (
              <Box mb={2}>
                <Autocomplete
                  id="region"
                  fullWidth
                  multiple
                  options={this.state.regionList}
                  value={this.state.selectedRegion || []}
                  onChange={(e: any, newValue: IReferential[]) => this.handleRegionChange(newValue)}
                  getOptionLabel={(option: IReferential) => option.displayName || ''}
                  renderInput={(params) => (
                    <TextValidator
                      {...params}
                      name="region"
                      value={this.state.selectedRegion[0] || ''}
                      label={this.translatorService.Tranlate(
                        'TARIFF_EDIT_LABOR_TAB_REGION_LABEL',
                        'Regiune'
                      )}
                      fullWidth
                      validators={['required']}
                      errorMessages={[
                        this.translatorService.Tranlate('VALIDATORS_REQUIRED', 'Campul este obligatoriu')
                      ]}
                    />
                  )}
                />
              </Box>
            )
          )}
          {this.props.tariffGroupTypeCode === TariffCategoryCodeEnum.ADAOS.toString() ? null : (
            !this.hasRight(RoleClaimsEnum.AdminService) && (
              <Box mb={2}>
                <Autocomplete
                  id="vehicleType"
                  fullWidth
                  multiple
                  options={this.state.vehicleTypeList}
                  value={this.state.selectedVehicleType || []}
                  onChange={(e: any, newValue: IReferential[]) => this.handleVehicleTypeChange(newValue)}
                  getOptionLabel={(option: IReferential) => option.displayName || ''}
                  renderInput={(params) => (
                    <TextValidator
                      {...params}
                      name="vehicleType"
                      value={this.state.selectedVehicleType[0] || ''}
                      label={this.translatorService.Tranlate(
                        'TARIFF_EDIT_LABOR_TAB_VEHICLE_TYPE_LABEL',
                        'Tip vehicul'
                      )}
                      fullWidth
                      validators={['required']}
                      errorMessages={[
                        this.translatorService.Tranlate('VALIDATORS_REQUIRED', 'Campul este obligatoriu')
                      ]}
                    />
                  )}
                />
              </Box>
            )
          )}
          {this.props.tariffGroupTypeCode === TariffCategoryCodeEnum.ADAOS.toString() ? null : (
            !this.hasRight(RoleClaimsEnum.AdminService) && (
              <Box mb={2}>
                <Autocomplete
                  id="jobType"
                  fullWidth
                  multiple
                  options={this.state.jobTypeList}
                  value={this.state.selectedJobType || []}
                  onChange={(e: any, newValue: IReferential[]) => this.handleJobTypeChange(newValue)}
                  getOptionLabel={(option: IReferential) => option.displayName || ''}
                  renderInput={(params) => (
                    <TextValidator
                      {...params}
                      name="jobType"
                      value={this.state.selectedJobType[0] || ''}
                      label={this.translatorService.Tranlate(
                        'TARIFF_EDIT_LABOR_TAB_JOB_TYPE_LABEL',
                        'Tip Lucrare'
                      )}
                      fullWidth
                      validators={['required']}
                      errorMessages={[
                        this.translatorService.Tranlate('VALIDATORS_REQUIRED', 'Campul este obligatoriu')
                      ]}
                    />
                  )}
                />
              </Box>
            )
          )}
          {this.props.tariffGroupTypeCode === TariffCategoryCodeEnum.ADAOS.toString() ? null : (
            !this.hasRight(RoleClaimsEnum.AdminService) && (
              <Box mb={2}>
                <Autocomplete
                  id="insurer"
                  fullWidth
                  multiple
                  options={this.state.insurerList}
                  value={this.state.selectedInsurer || []}
                  onChange={(e: any, newValue: IReferential[]) => this.handleInsurerChange(newValue)}
                  getOptionLabel={(option: IReferential) => option.name || ''}
                  renderInput={(params) => (
                    <TextValidator
                      {...params}
                      name="insurer"
                      value={this.state.selectedInsurer[0] || ''}
                      label={this.translatorService.Tranlate(
                        'TARIFF_EDIT_LABOR_TAB_INSURER_LABEL',
                        'Asigurator'
                      )}
                      fullWidth
                      validators={['required']}
                      errorMessages={[
                        this.translatorService.Tranlate('VALIDATORS_REQUIRED', 'Campul este obligatoriu')
                      ]}
                    />
                  )}
                />
              </Box>
            )
          ) }
          <Box mb={2}>
            <Autocomplete
              id="tariffType"
              fullWidth
              multiple
              filterSelectedOptions
              options={this.state.tariffTypeList}
              getOptionLabel={(option: TariffType) => option.displayName}
              value={this.state.selectedTariffTypes}
              onChange={(e: any, newValue: TariffType[]) => this.handleTariffTypeChange(e, newValue)}
              renderInput={(params: RenderInputParams) => (
                <TextValidator
                  {...params}
                  name="tariffType"
                  fullWidth
                  value={this.state.selectedTariffTypes[0] || ''}
                  label={this.props.tariffGroupTypeName}
                  validators={['required']}
                  errorMessages={[
                    this.translatorService.Tranlate('VALIDATORS_REQUIRED', 'Campul este obligatoriu')
                  ]}
                />
              )}
            />
          </Box>
          {!this.shouldShowBrandDropdown() ? null : (
            <Box mb={2}>
              <Autocomplete
                id="brand"
                fullWidth
                multiple
                options={this.state.brandList}
                value={this.state.selectedBrands || ''}
                onChange={(e: any, newValue: IReferential[]) => this.handleBrandChange(newValue)}
                getOptionLabel={(option: IReferential) => option.name || ''}
                renderInput={(params) => (
                  <TextValidator
                    {...params}
                    name="brand"
                    value={this.state.selectedBrands[0] || ''}
                    label={this.translatorService.Tranlate(
                      'TARIFF_EDIT_LABOR_TAB_BRAND_LABEL',
                      'Marca'
                    )}
                    fullWidth
                    validators={['required']}
                    errorMessages={[
                      this.translatorService.Tranlate('VALIDATORS_REQUIRED', 'Campul este obligatoriu')
                    ]}
                  />
                )}
              />
            </Box>
          )}
        
          {this.props.tariffGroupTypeCode === TariffCategoryCodeEnum.ADAOS.toString() || 
            this.props.tariffGroupTypeCode === TariffCategoryCodeEnum.ADAOS_ASIGURATOR.toString() || 
            this.props.tariffGroupTypeCode === TariffCategoryCodeEnum.ADAOS_ALT_PART.toString() || 
            this.props.tariffGroupTypeCode ===  TariffCategoryCodeEnum.DISC  ? null :
            (
            <div>
              <FormControlLabel
                control={
                  <Switch
                    checked={this.state.isVehicleAge}
                    onChange={(e: any) =>
                      this.setState({
                        isVehicleAge: e.currentTarget.checked
                      })
                    }
                    color="primary"
                    id="isActive"
                    inputProps={{
                      'aria-label': 'primary checkbox'
                    }}
                  />
                }
                label={this.translatorService.Tranlate(
                  'TARIFF_EDIT_LABOR_TAB_HAS_INTERVAL_LABEL',
                  'Stare'
                )}
              />
            </div>
          )}

          {!this.state.isVehicleAge ? null : (
            <Grid container alignContent="center" className="mt-4" alignItems="center" spacing={4}>
              <Grid item xs={8}>
                <Slider
                  className="ml-2 mr-2"
                  disabled={!this.state.isVehicleAge}
                  value={this.state.selectedSliderValues}
                  onChange={this.handleChange}
                  valueLabelDisplay="on"
                  aria-labelledby="range-slider"
                  max={END}
                  step={1}
                  min={START}
                  marks={this.getMarks(END)}
                  track={false}
                />
              </Grid>
              <Grid item xs={4}>
                <IconButton onClick={this.removeSliderValue}>
                  <RemoveIcon />
                </IconButton>
                <IconButton onClick={this.addSliderValue}>
                  <AddCircleTwoToneIcon />
                </IconButton>
              </Grid>
            </Grid>
          )}

          <Grid container alignContent="center" className="" alignItems="center" spacing={0}>
            {!this.state.isVehicleAge
              ? null
              : this.state.selectedValues.map((value: number, index: number) => (
                  <React.Fragment key={index}>
                    <Grid item xs={6} key={index}>
                      <TextValidator
                        key={index}
                        name="value"
                        className="w-50"
                        id="name"
                        type="value"
                        value={value}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                          this.handleValuesChange(e, index)
                        }
                        label={
                          this.translatorService.Tranlate(
                            'TARIFF_EDIT_LABOR_TAB_VALUE_LABEL',
                            'Valoare'
                          ) +
                          '(' +
                          index +
                          ')'
                        }
                        validators={this.getValidators()}
                        errorMessages={this.getErrorMessages()}
                        InputProps={{
                          inputComponent: this.NumberFormatCustom
                        }}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      {!this.hasRight(RoleClaimsEnum.AdminService) && (
                        <TextValidator
                          key={index}
                          name="offerValue"
                          className="w-50"
                          id="name"
                          type="value"
                          value={this.state.selectedOfferValues[index]}
                          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                            this.handleOfferValuesChange(e, index)
                          }
                          label={
                            this.translatorService.Tranlate(
                              'TARIFF_EDIT_LABOR_TAB_OFFER_VALUE_LABEL',
                              'Valoare'
                            ) +
                            '(' +
                            index +
                            ')'
                          }
                          validators={this.getValidators()}
                          errorMessages={this.getErrorMessages()}
                          InputProps={{
                            inputComponent: this.NumberFormatCustom
                          }}
                        />
                      )}
                    </Grid>
                  </React.Fragment>
                ))}
          </Grid>

          {this.state.isVehicleAge ? null : (
            <Grid container alignContent="center" className="mt-1" alignItems="center" spacing={0}>
              {
                this.props.tariffGroupTypeCode === TariffCategoryCodeEnum.ADAOS.toString() ? (
                  <>
                    <Grid item xs={4}>
                      <TextValidator
                        name="value"
                        className="w-50 mt-2"
                        id="name"
                        type="value"
                        value={this.state.selectedValue}
                        onChange={this.handleValueChange}
                        label={this.translatorService.Tranlate(
                          'TARIFF_EDIT_LABOR_TAB_STATIC_VALUE_LABEL',
                          'Valoare'
                        )}
                        validators={
                          this.props.tariffGroupTypeCode === TariffCategoryCodeEnum.MAN.toString()
                            ? ['required', 'isGreaterThanZero']
                            : ['required']
                        }
                        errorMessages={
                          this.props.tariffGroupTypeCode === TariffCategoryCodeEnum.MAN.toString()
                            ? [
                                this.translatorService.Tranlate(
                                  'VALIDATORS_REQUIRED',
                                  'Campul este obligatoriu'
                                ),
                                this.translatorService.Tranlate(
                                  'LABOR_VALUE_SHOULD_BE_GREATER_THAN_ZERO',
                                  'Valoarea trebuie sa fie mai mare decat 0'
                                ),
                              ]
                            : [
                                this.translatorService.Tranlate(
                                  'VALIDATORS_REQUIRED',
                                  'Campul este obligatoriu'
                                ),
                              ]
                        }
                        InputProps={{
                          inputComponent: this.NumberFormatCustom
                        }}
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <TextValidator
                        name="value"
                        className="w-50 mt-2"
                        id="name"
                        type="value"
                        value={this.state.selectedMarginValue}
                        onChange={this.handleMarginValueChange}
                        label={this.translatorService.Tranlate(
                          'TARIFF_EDIT_LABOR_TAB_MARGIN_VALUE_LABEL',
                          'Valoare Deviz'
                        )}
                        validators={
                          this.props.tariffGroupTypeCode === TariffCategoryCodeEnum.MAN.toString()
                            ? ['required', 'isGreaterThanZero']
                            : ['required']
                        }
                        errorMessages={
                          this.props.tariffGroupTypeCode === TariffCategoryCodeEnum.MAN.toString()
                            ? [
                                this.translatorService.Tranlate(
                                  'VALIDATORS_REQUIRED',
                                  'Campul este obligatoriu'
                                ),
                                this.translatorService.Tranlate(
                                  'LABOR_VALUE_SHOULD_BE_GREATER_THAN_ZERO',
                                  'Valoarea trebuie sa fie mai mare decat 0'
                                ),
                              ]
                            : [
                                this.translatorService.Tranlate(
                                  'VALIDATORS_REQUIRED',
                                  'Campul este obligatoriu'
                                ),
                              ]
                        }
                        InputProps={{
                          inputComponent: this.NumberFormatCustom
                        }}
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <TextValidator
                        name="value"
                        className="w-50 mt-2"
                        id="name"
                        type="value"
                        value={this.state.selectedOfferValue}
                        onChange={this.handleOfferValueChange}
                        label={this.translatorService.Tranlate(
                          'TARIFF_EDIT_LABOR_TAB_PROCENT_VALUE_LABEL',
                          'Procent'
                        )}
                        validators={
                          this.props.tariffGroupTypeCode === TariffCategoryCodeEnum.MAN.toString()
                            ? ['required', 'isGreaterThanZero']
                            : ['required']
                        }
                        errorMessages={
                          this.props.tariffGroupTypeCode === TariffCategoryCodeEnum.MAN.toString()
                            ? [
                                this.translatorService.Tranlate(
                                  'VALIDATORS_REQUIRED',
                                  'Campul este obligatoriu'
                                ),
                                this.translatorService.Tranlate(
                                  'LABOR_VALUE_SHOULD_BE_GREATER_THAN_ZERO',
                                  'Valoarea trebuie sa fie mai mare decat 0'
                                ),
                              ]
                            : [
                                this.translatorService.Tranlate(
                                  'VALIDATORS_REQUIRED',
                                  'Campul este obligatoriu'
                                ),
                              ]
                        }
                        InputProps={{
                          inputComponent: this.NumberFormatCustom
                        }}
                      />
                    </Grid>
                  </>
                ) : (
                  <>
                    <Grid item xs={4}>
                      <TextValidator
                        name="value"
                        className="w-50"
                        id="name"
                        type="value"
                        value={this.state.selectedValue}
                        onChange={this.handleValueChange}
                        label={this.props.tariffGroupTypeCode === TariffCategoryCodeEnum.DISC ? 
                          this.translatorService.Tranlate(
                            'TARIFF_EDIT_DISCOUNT_TAB_VALUE_LABEL',
                            'Procent %'
                          ) :
                          this.translatorService.Tranlate(
                            'TARIFF_EDIT_LABOR_TAB_VALUE_LABEL',
                            'Valoare'
                          )
                        }
                        validators={this.getValidators()}
                        errorMessages={this.getErrorMessages()}
                        InputProps={{
                          inputComponent: this.NumberFormatCustom
                        }}
                      />
                    </Grid>
                    {this.props.tariffGroupTypeCode === TariffCategoryCodeEnum.MAN.toString() ? (
                      <Grid item xs={4}>
                        <TextValidator
                          name="currency"
                          className="w-50"
                          id="currency"
                          type="value"
                          disabled={true}
                          value={this.props.currency}
                          onChange={this.handleValueChange}
                          label={this.translatorService.Tranlate(
                            'TARIFF_EDIT_LABOR_TAB_CURRENCY_LABEL',
                            'Moneda'
                          )}
                        />
                      </Grid>
                    ) : (
                      <Grid item xs={4}>
                      </Grid>
                    )}
                    <Grid item xs={4}>
                      {!this.hasRight(RoleClaimsEnum.AdminService) && (
                        <TextValidator
                          name="value"
                          className="w-50"
                          id="name"
                          type="value"
                          value={this.state.selectedOfferValue}
                          onChange={this.handleOfferValueChange}
                          label={this.translatorService.Tranlate(
                            'TARIFF_EDIT_LABOR_TAB_OFFER_VALUE_LABEL',
                            'Valoare'
                          )}
                          validators={this.getValidators()}
                          errorMessages={this.getErrorMessages()}
                          InputProps={{
                            inputComponent: this.NumberFormatCustom
                          }}
                        />
                      )}
                    </Grid>
                  </>
                )

              }
          
            </Grid>
          )}
          <div className="text-right m-2">
            <Button
              className="m-2"
              variant="outlined"
              color="default"
              onClick={() => {
                this.setState({ activeAction: 0 });
              }}
            >
              {this.translatorService.Tranlate('TARIFF_EDIT_LABOR_TAB_CANCEL_BUTTON', 'Anuleaza')}
            </Button>
            <Button className="m-2" variant="contained" color="secondary" type="submit">
              {this.translatorService.Tranlate('TARIFF_EDIT_LABOR_TAB_SAVE_BUTTON', 'Salveaza')}
            </Button>
          </div>
        </Box>
      </ValidatorForm>
    );
  };

  structureTariffValuesAccordingToDate = () => {
    const dataLaborServices = [] as DateLaborService[];

    this.state.tariffValues.forEach((tariffValue: TariffValue) => {
      const index = dataLaborServices.findIndex(
        (item: DateLaborService) => item.date.toString() === tariffValue.date.toString()
      );

      if (index !== -1) {
        dataLaborServices[index].tariffValues.push(tariffValue);
      } else {
        dataLaborServices.push({
          date: tariffValue.date,    
          tariffValues: [tariffValue]
        });
      }
    });
    //dataLaborServices = dataLaborServices.sort().reverse();

    return dataLaborServices;
  };

  renderTariffValues = (list: TariffValue[]) => {
    list = list.sort((a: TariffValue, b: TariffValue) => {
      return this.compareName(a.brand!, b.brand!);
    });
    return this.props.tariffGroupTypeCode == TariffCategoryCodeEnum.ADAOS.toString() ? (list.map((item) => (
      <p key={item.id}>
        {(item.brand === null ? this.defaultBrand.displayName : item.brand.displayName) +
          ' ' +
          this.renderVehicleAge(item) +
          ' - ' +
          item.value +
          ' (' +
          item.marginValue +
          ') ' +
          item.offerValue}
      </p>
    ))) : (list.map((item) => (
      <p key={item.id}>
        {(item.brand === null ? this.defaultBrand.displayName : item.brand.displayName) +
          ' ' +
          this.renderVehicleAge(item) +
          ' - ' +
          item.value +
          (
            !this.hasRight(RoleClaimsEnum.AdminService) ? (
              ' (' +
              item.offerValue +
              ')'
            ) : ''
          )}
      </p>
    )));
  };

  renderVehicleAge = (tv: TariffValue) => {
    if (tv.startVehicleYear === null && tv.endVehicleYear === null) {
      return '';
    }
    const start = tv.startVehicleYear === null ? '0' : tv.startVehicleYear;
    const end = tv.endVehicleYear === null ? '' : tv.endVehicleYear;

    return '(' + start + '<' + end + ')';
  };

  getDistinctTariffTypes = (tariffValues: TariffValue[]) => {
    return tariffValues
      .map((item) => item.tariffType)
      .filter((tt, index, arr) => arr.findIndex((i) => i.id === tt.id) == index);
  };

  getDistinctInsurer = (tariffValues: TariffValue[]) => {
    return _.map(_.groupBy(tariffValues, 'insurerId'),
      (items) => ({
          insurer: items[0].insurer,
          tariffValues: items,
      }));
  };

  getDistinctVehicleType = (tariffValues: TariffValue[]) => {
    return _.map(_.groupBy(tariffValues, 'vehicleTypeId'),
      (items) => ({
          vehicleType: items[0].vehicleType,
          tariffValues: items,
      }));
  };

  getDistinctRegion = (tariffValues: TariffValue[]) => {
    return _.map(_.groupBy(tariffValues, 'regionId'),
      (items) => ({
          region: this.state.regionList.find((r) => r.id === items[0].regionId) || null,
          tariffValues: items,
      }));
  };

  getDistinctJobType = (tariffValues: TariffValue[]) => {
    return _.map(_.groupBy(tariffValues, 'jobTypeId'),
      (items) => ({
          jobType: this.state.jobTypeList.find((j) => j.id === items[0].jobTypeId) || null,
          tariffValues: items,
      }));
  };

  deleteTariff = async (date: Date) => {
    try {
      const dateLocal = moment.utc(date.toDateString()).local().toDate();
      await this.tariffService.DeleteTariffValues(this.props.tariffId, dateLocal);

      this.setState(
        {
          isLoading: true
        },
        () => {
          this.loadData();
        }
      );

      this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
        variant: 'success'
      });
    } catch (err) {
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    }
  };

  showTimelineTariff = () => {
    const dataLaborServices = this.structureTariffValuesAccordingToDate();
    if (dataLaborServices.length === 0) {
      return (
        <b>
          {this.translatorService.Tranlate(
            'TARIFF_EDIT_LABOR_TAB_NO_DATA',
            'Nu exista date de afisat!'
          )}
        </b>
      );
    }

    return dataLaborServices.map((dateTariff) => (
      <div key={dateTariff.date.toString()} className="timeline-item">
        <div className="timeline-item--content">
          <div className="timeline-item--icon" />
          <h4 className="timeline-item--label mb-2 font-weight-bold">
            {moment(dateTariff.date).format(this.props.appState.dateFormat)}
            {moment(dateTariff.date).toDate() > new Date() ? (
              <Tooltip
                title={this.translatorService.Tranlate(
                  'TARIFF_EDIT_LABOR_TAB_DELETE_BUTTON',
                  'Sterge'
                )}
              >
                <IconButton
                  aria-label="edit"
                  color="default"
                  size="small"
                  className=""
                  onClick={() => this.deleteTariff(moment(dateTariff.date).toDate())}
                >
                  <DeleteCircleTwoToneIcon />
                </IconButton>
              </Tooltip>
            ) : null}
          </h4>
          {this.getDistinctRegion(dateTariff.tariffValues).map((regionItem) => (
            <React.Fragment key={(regionItem.region?.id ?? 'none') + ''}>
              <h4 className="timeline-item--label mb-2 mt-2 font-weight-bold">
                {this.translatorService.Tranlate('TARIFF_EDIT_LABOR_TAB_REGION_LABEL', 'Regiune')}: {regionItem.region ? regionItem.region!.displayName : this.translatorService.Tranlate('SELECT_ALL_OPTION', 'Toate')}
              </h4>
              {this.getDistinctVehicleType(regionItem.tariffValues).map((vtItem) => (
                <React.Fragment key={(vtItem.vehicleType?.id ?? 'none') + ''}>
                  <h4 className="timeline-item--label mb-2 mt-2 font-weight-bold">
                    {this.translatorService.Tranlate('TARIFF_EDIT_LABOR_TAB_VEHICLE_TYPE_LABEL', 'Tip vehicul')}: {vtItem.vehicleType ? vtItem.vehicleType!.displayName : this.translatorService.Tranlate('SELECT_ALL_OPTION', 'Toate')}
                  </h4>
                  {this.getDistinctJobType(vtItem.tariffValues).map((jtItem) => (
                    <React.Fragment key={(jtItem.jobType?.id ?? 'none') + ''}>
                      <h4 className="timeline-item--label mb-2 mt-2 font-weight-bold">
                        {this.translatorService.Tranlate('TARIFF_EDIT_LABOR_TAB_JOB_TYPE_LABEL', 'Tip Lucrare')}: {jtItem.jobType ? jtItem.jobType!.displayName : this.translatorService.Tranlate('SELECT_ALL_OPTION', 'Toate')}
                      </h4>
                      {this.getDistinctInsurer(jtItem.tariffValues).map((insurerItem) => (
                        <React.Fragment key={(insurerItem.insurer?.id ?? 'none') + ''}>
                          <h4 className="timeline-item--label mb-2 mt-2 font-weight-bold">
                            {this.translatorService.Tranlate('TARIFF_EDIT_LABOR_TAB_INSURER_LABEL', 'Asigurator')}: {insurerItem.insurer ? insurerItem.insurer!.displayName : this.translatorService.Tranlate('SELECT_NONE_OPTION', 'Niciunul')}
                          </h4>
                          <Grid container>
                            {this.getDistinctTariffTypes(insurerItem.tariffValues).map((tt) => {
                              const tariffValues = insurerItem.tariffValues.filter(
                                (item) => item.tariffTypeId === tt.id
                              );

                              return (
                                <Grid item xs={2} key={tt.id}>
                                  <h6> {tt.displayName} </h6>
                                  {this.renderTariffValues(tariffValues)}
                                </Grid>
                              );
                            })}
                          </Grid>
                        </React.Fragment>
                      ))}
                    </React.Fragment>
                  ))}
                </React.Fragment>
              ))}
            </React.Fragment>
          ))}
         
        </div>
      </div>
    ));
  };

  editInsertTarifLaborButton = (button: number) => {
    const dataLaborServices = this.structureTariffValuesAccordingToDate();

    if (button === 2) {
      this.setState({
        activeAction: button,
        selectedDate: new Date(),
        minDate: new Date()
      });
    } else {
      this.setState({
        activeAction: button,
        selectedDate: new Date(),
        minDate: new Date()
      });
    }
  };

  public render() {
    this.translatorService = (this.context as AppContext).translatorService;
    this.tariffService = (this.context as AppContext).tariffService;
    this.appReferentialService = (this.context as AppContext).referentialService;
    this.caseService = (this.context as AppContext).caseService;

    return (
      <Fragment>
        <Box mt={1} pt={1}>
          {this.state.tariffValues.length > 0 ? (
            <Card className="card-box p-1 mb-4">
              <div className="m-1 text-right">
                <Tooltip
                  title={this.translatorService.Tranlate(
                    'TARIFF_EDIT_LABOR_TAB_UPDATE_BUTTON',
                    'Actualizeaza'
                  )}
                >
                  <IconButton
                    aria-label="edit"
                    color="primary"
                    className="m-2"
                    onClick={() => this.editInsertTarifLaborButton(1)}
                  >
                    <EditCircleTwoToneIcon />
                  </IconButton>
                </Tooltip>
                <Tooltip
                  title={this.translatorService.Tranlate(
                    'TARIFF_EDIT_LABOR_TAB_ADD_BUTTON',
                    'Adauga'
                  )}
                >
                  <IconButton
                    aria-label="add"
                    color="secondary"
                    className="m-2"
                    onClick={() => this.editInsertTarifLaborButton(2)}
                  >
                    <AddCircleTwoToneIcon />
                  </IconButton>
                </Tooltip>
              </div>

              {this.state.activeAction !== 0
                ? this.renderEditTariffValues(this.state.activeAction)
                : null}
            </Card>
          ) : (
            <Card className="card-box p-1 mb-4">
              <div className="m-1 text-right">
                <Tooltip
                  title={this.translatorService.Tranlate(
                    'TARIFF_EDIT_LABOR_TAB_ADD_BUTTON',
                    'Adauga'
                  )}
                >
                  <IconButton
                    aria-label="add"
                    color="secondary"
                    className="m-2"
                    onClick={() => this.editInsertTarifLaborButton(2)}
                  >
                    <AddCircleTwoToneIcon />
                  </IconButton>
                </Tooltip>
              </div>

              {this.state.activeAction !== 0
                ? this.renderEditTariffValues(this.state.activeAction)
                : null}
            </Card>
          )}
        </Box>

        <Box>
          <Card className="card-box p-1 mb-4">
            <Grid item xs={12} container direction="column" className="ml-0" spacing={1}>
              <Grid item xs className="">
                <div className="timeline-list  timeline-list--primary m-2 p-3">
                  {' '}
                  {this.showTimelineTariff()}{' '}
                </div>
              </Grid>
            </Grid>
          </Card>
        </Box>
      </Fragment>
    );
  }
}

const mergeProps = (
  stateProps: any,
  dispatchProps: any,
  ownProps: ExternalEditTarifLaborTabProps
) => ({
  ...ownProps,
  ...stateProps,
  ...dispatchProps
});
export default connect(
  (state: ApplicationState) => ({ appState: state.app }),
  { ...AppUserAdminActionCreators, ...AppActionCreators },
  mergeProps
)(withSnackbar(EditTarifLaborTabf as any));
